<template>
	<div class="wrap">

		<!-- 面包屑导航区 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item class="test" :to="{ path: '/lianxiwomen' }">加入我们 设置</el-breadcrumb-item>
			<el-breadcrumb-item>添加招聘岗位</el-breadcrumb-item>
		</el-breadcrumb>

		<el-card>
			<el-form label-width="80px" :model="formData">
				<!-- :label-position="labelPosition" :model="formLabelAlign" -->
				<el-form-item label="岗位权重">
					<el-input v-model="formData.weights" style="width: 70px;" type="number"></el-input>
					<el-tag style="margin-left: 20px;" type="danger">权重越高，排序越靠前</el-tag><!-- v-model="formLabelAlign.region" -->
				</el-form-item>
				<el-form-item label="职位">
					<el-input v-model="formData.name"></el-input>
				</el-form-item>
				<el-form-item label="岗位类型">
					<el-input v-model="formData.type"></el-input>
				</el-form-item>
				<el-form-item label="所属部门">
					<el-input v-model="formData.departmentName"></el-input><!-- v-model="formLabelAlign.region" -->
				</el-form-item>
				<el-form-item label="地址">
					<el-input v-model="formData.address"></el-input><!-- v-model="formLabelAlign.region" -->
				</el-form-item>
				<el-form-item label="岗位详情">
					<!-- 图片上传组件辅助-->
					<el-upload class="avatar-uploader" :action="uploadUrl" type="drag" :show-file-list="false" :on-success="uploadSuccess">
					</el-upload>
					<!-- 富文本编辑器 -->
					<quill-editor v-model="formData.quillData" :options="editorOption" ref="myref"></quill-editor>
				</el-form-item>

			</el-form>

			<!-- 添加商品 -->
			<el-button type="success" class="submitBtn" @click="submit">立即提交</el-button>
		</el-card>

	</div>
</template>

<script>
	const toolbarOptions = [
		['bold', 'italic', 'underline', 'strike'], // toggled buttons
		['blockquote', 'code-block'],

		[{
			'header': 1
		}, {
			'header': 2
		}], // custom button values
		[{
			'list': 'ordered'
		}, {
			'list': 'bullet'
		}],
		[{
			'script': 'sub'
		}, {
			'script': 'super'
		}], // superscript/subscript
		[{
			'indent': '-1'
		}, {
			'indent': '+1'
		}], // outdent/indent
		[{
			'direction': 'rtl'
		}], // text direction

		[{
			'size': ['12px', '14px', false, '18px', '22px', '26px', '30px', '36px', '42px']
		}], // custom dropdown
		[{
			'header': [1, 2, 3, 4, 5, 6, false]
		}],

		[{
			'color': []
		}, {
			'background': []
		}], // dropdown with defaults from theme
		[{
			'font': []
		}],
		[{
			'align': []
		}],
		['link', 'image', 'video'],
		['clean'] // remove formatting button
	]
	import {
		quillRedefine
	} from 'vue-quill-editor-upload' //引入图片上传
	
	import ImageResize from 'quill-image-resize-module'
	Quill.register('modules/imageResize', ImageResize) 
	
	export default {
		components: {

		},
		data() {
			return {
				id: '',
				uploadUrl: this.$httpTitle + '/uploadImgQiniugroup?pathName=activityNewInfo',
				/* fileList: [{name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}, {name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}], */
				fileList: [],
				fileList2: [],
				detailData: {},
				quillData: '',
				formData: {
					weights: '',
					mame: '',
					type: '',
					departmentName: '',
					address: '',
					quillData: '',
					introduction: '',

				},

				editorOption: {
					theme: 'snow', // or 'bubble'
					modules: {
						imageResize: { //放大缩小
							displaySize: true
						},
						toolbar: {
							container: toolbarOptions, // 工具栏
							handlers: {
								'image': function(value) {
									if (value) {
										// 触发input框选择图片文件
										document.querySelector('.avatar-uploader input').click()
									} else {
										this.quill.format('image', false);
									}
								}
							}
						}
					}
				},

			}
		},
		created() {
			console.log('传过来的id=' + this.$route.query.id)
			this.id = this.$route.query.id;
			/* var that = this
			setTimeout(function() {
				console.log(that.$refs.myref.quill)
			}, 100) */
			this.getData()

			var data = {
				"data": {
					"code": 0,
					"message": "success.",
					"data": {
						"id": 4,
						"createTime": 1592293264000,
						"updateTime": 1592293266000,
						"jobType": "1",
						"jobName": "平面包装设计",
						"positionType": "1",
						"positionName": "设计",
						"departmentType": "1",
						"departmentName": "设计部",
						"address": "广东广州",
						"content": "<p>\r\n    <span style=\"font-size: 16px; background-color: rgb(146, 205, 220); --darkreader-inline-bgcolor:#8bb6bd;\"><strong><span style=\"font-size: 16px; background-color: rgb(146, 205, 220); font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; --darkreader-inline-bgcolor:#8bb6bd;\">01岗位职责</span></strong></span><span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\"><br/></span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">1、负责公司各个渠道的整体形象设计、商品展示设计、详情页优化、整体布局、活动推广等；</span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">2、根据每月制定的促销计划、活动策划，设计相关广告logo、banner、海报并对效果进行跟踪；</span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">3、负责公司对外宣传物料设计、节日海报设计、产品包装设计；</span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">4、完成上级领导安排的其他工作。</span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\"><br/></span>\r\n</p>\r\n<p>\r\n    <span style=\"background-color: rgb(146, 205, 220); --darkreader-inline-bgcolor:#8bb6bd;\"><strong><span style=\"background-color: rgb(146, 205, 220); font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 16px; --darkreader-inline-bgcolor:#8bb6bd;\">02任职要求</span></strong></span><span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\"><br/></span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">1、熟练掌握PS、AI、CDR等相关设计软件操作；</span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\"><span style=\"font-family: 宋体;\">2、有2年以上平面设计经验，有较强的视觉效果功底，美术、设计、广告等相关专业，新手不考虑</span><span style=\"color: rgb(38, 43, 51); background: rgb(255, 255, 255) none repeat scroll 0% 0%; font-family: 宋体; --darkreader-inline-color:#353737; --darkreader-inline-bgcolor:#e1dcd2; --darkreader-inline-bgimage:none;\">；</span></span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\"><span style=\"color: rgb(38, 43, 51); background: rgb(255, 255, 255) none repeat scroll 0% 0%; font-family: 宋体; --darkreader-inline-color:#353737; --darkreader-inline-bgcolor:#e1dcd2; --darkreader-inline-bgimage:none;\"><br/></span></span>\r\n</p>\r\n<p>\r\n    <img src=\"http://group.jiuhangjituan.cn/activityNewInfo/202006161547325582553.jpg\" title=\"activityNewInfo/202006161547325582553.jpg\" alt=\"微信图片_20200615163808.jpg\"/>\r\n</p>",
						"weights": 4
					}
				},
				"status": 200,
				"statusText": "",
				"headers": {
					"date": "Thu, 02 Jul 2020 05:15:54 GMT",
					"transfer-encoding": "chunked",
					"content-type": "application/json;charset=UTF-8"
				},
				"config": {
					"url": "/v1/official/manag/recruitment/job/detail",
					"method": "get",
					"params": {
						"id": 4
					},
					"headers": {
						"Accept": "application/json, text/plain, */*",
						"Authorization": "1:52F5CC6821537C8D9FCA31E8B3EB9BD3A3E18B94CA015773"
					},
					"baseURL": "http://xhm.jiuhuakang.com",
					"transformRequest": [null],
					"transformResponse": [null],
					"timeout": 0,
					"xsrfCookieName": "XSRF-TOKEN",
					"xsrfHeaderName": "X-XSRF-TOKEN",
					"maxContentLength": -1
				},
				"request": {}
			}
		},
		methods: {
			async getData() {
				console.log('id=' + this.id)
				/* 2.在招岗位详情/v1/official/manag/recruitment/job/detail  get请求 参数 int id; */
				var res = await this.$http.get('/v1/official/manag/recruitment/job/detail', {
					params: {
						id: this.id
					}
				})
				console.log(JSON.stringify(res))
				if (res.data.code == 0) {
					this.formData.weights = res.data.data.weights
					this.formData.name = res.data.data.positionName
					this.formData.type = res.data.data.jobName
					this.formData.departmentName = res.data.data.departmentName
					this.formData.quillData = res.data.data.content
					this.formData.address = res.data.data.address
				} else {
					this.$message.error(res.data.message)
				}
			},
			onRemove(file, fileList) {
				console.log('fileList=' + JSON.stringify(fileList))
				this.fileList2 = [];
			},
			onSuccess(res) {
				console.log('res=' + JSON.stringify(res))
				this.fileList2.push(res)
			},

			uploadSuccess(res, file) { // res为图片服务器返回的数据
				var that = this
				console.log('uploadSuccess res=' + JSON.stringify(res))
				setTimeout(function() {
					console.log("194=" + that.$refs.myref)
					let quill = that.$refs.myref.quill;

					if (res) {
						let length = quill.getSelection().index; // 获取光标所在位置
						quill.insertEmbed(length, 'image', that.$imgTitle + res); // 插入图片  res.info为服务器返回的图片地址
						quill.setSelection(length + 1); // 调整光标到最后
					} else {
						that.$message.error('图片插入失败')
					}
					that.quillUpdateImg = false; // loading动画消失
				}, 0)

			},
			async submit() {
				/* 3.在招岗位修改/v1/official/manag/recruitment/job/update post请求 参数 int id,String jobType,
				String jobName,String positionType,
				String positionName,String departmentType,String departmentName,String address,String content,Integer weights */
				var obj = {};
				obj['id'] = this.id;
				obj['jobType'] = this.formData.type
				obj['jobName'] = this.formData.type
				obj['positionType'] = 1
				obj['positionName'] = this.formData.name
				obj['departmentType'] = 1
				obj['departmentName'] = this.formData.departmentName
				obj['address'] = this.formData.address
				obj['content'] = this.formData.quillData
				obj['weights'] = +this.formData.weights

				console.log(JSON.stringify(obj))
				
				if (obj.weights == '' || obj.jobType == '' || obj.jobName == '' || obj.address == '' || obj.content == '' || obj.departmentName ==
					'') {
					return this.$message.error('请添加必要的参数!')
				}

				const res = await this.$http.post('/v1/official/manag/recruitment/job/update', {
					request: obj
				})
				console.log('res=' + JSON.stringify(res))
				if (res.data.code == 0) {
					this.$message.success('修改成功')
					this.$router.push({
						path: '/lianxiwomen'
					})
				} else {
					this.$message.error(res.data.message)
				}

			}
		}
	}
</script>

<style lang="less" scoped>
	.el-card {
		/* width: 1000px; */
	}

	.submitBtn {
		margin: 0 auto;
		margin-top: 90px;
		margin-left: 80px;
	}
</style>
